import { normalizedName } from "./normalizedName.ts";

/** Lowest `{base} {n}` (n ≥ 1) not already used, matched case-insensitively. */
export const nextNumberedName = (base: string, existing: Iterable<string>): string => {
  const taken = new Set([...existing].map(normalizedName));
  const nameAt = (index: number) => `${base} ${index}`;
  let index = 1;
  while (taken.has(normalizedName(nameAt(index)))) index += 1;
  return nameAt(index);
};
